import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VSelect,{attrs:{"items":_vm.items,"loading":_vm.isLoading,"item-text":_vm.itemText,"item-value":_vm.itemValue,"label":_vm.label,"placeholder":_vm.placeholder,"rules":_vm.rules,"error-messages":_vm.errorMessages,"hide-no-data":_vm.hideNoData,"validate-on-blur":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }